import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import MainLoading from "../Component/Main Loading/MainLoading";

const RequireAuth = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div>
        <MainLoading />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
};

export default RequireAuth;
